import styled from 'styled-components';

const SubmitButton = styled.button`
  display: inline-block;
  width: ${({ widthInRem }) => `${widthInRem}rem`};
  margin: 2rem calc((100% - ${({ widthInRem }) => `${widthInRem}rem`}) / 2) 0;
  padding: 2rem 1.5rem;
  text-align: center;
  color: ${({ theme }) => theme.color.activebg};
  border: 2px solid currentColor;
  border-radius: ${({ theme }) => theme.radius.basic};
  outline: none;
  background: none;
  cursor: pointer;
  transition: 0.25s;

  :hover {
    color: ${({ theme }) => theme.color.active};
  }
`;

export default SubmitButton;
